module["exports"] = ["محترم.", "محترمہ.", "ڈاکٹر"];
